import React from 'react';
import './CollectionPointsElement.scss';
import ArrowIcon from '../Icons/arrow-carousel-left.svg';
import WazeIcon from '../Icons/waze.png';
import Image from 'app/Components/Shared/Image/image';
const CollectionPointsElement = ({ point, onSelect, isExternal }) => {
  // isExternal מגיע מהבלוק הראשי - כל הנקודות יהיו אותו סוג

  const handleWazeClick = (e) => {
    e.stopPropagation(); // מונע הפעלת onSelect
    if (point.coordinates) {
      const coords = point.coordinates.split(',');
      const url = `https://waze.com/ul?ll=${coords[0]},${coords[1]}&navigate=yes`;
      window.open(url, '_blank');
    }
  };

  return (
    <div
      className={`CollectionPointItem ${isExternal ? 'external-type' : ''}`}
      onClick={() => !isExternal && onSelect?.(point)}
    >
      <div className='point-content'>
        <div className='station-address'>{point.stationAddress}, {point.cityAddress}</div>
        <div className='station-name'>{point.stationName}</div>
      </div>
      <div className='action-icon'>
        {isExternal ? (
          <button className='waze-button' onClick={handleWazeClick}>
            <Image src={WazeIcon} alt='waze' className='waze-icon' />
            <span className='waze-text'>ניווט</span>
          </button>
        ) : (
          <button className='arrow-button' onClick={() => onSelect?.(point)}>
            <Image src={ArrowIcon} alt='arrow' />
          </button>
        )}
      </div>
    </div>
  );
};

export default CollectionPointsElement;
